







import {
  EbtoEmployerResult,
} from "@/admin/types";
import {
  Vue,
  Component,
  Prop
} from "@/shared/vuepack";
import { Validator } from "vee-validate";
import CampaignDetail from "@/shared/components/ebto/campaign-detail.vue";

@Component({
  components: {
    CampaignDetail
  }
})
export default class ViewEditCampaign extends Vue {
  $validator: Validator;
  campaignEdit = false;

  title = "Need Campaign";
  @Prop({ required: false })
  campaignKey: string;

  employer: EbtoEmployerResult = {
    id: 1,
    name: "New Employ",
    externalEmployerId: "5465484"
  };
}
